/**
 * RTK Query refetch throws if the hook was skipped or the component unmounted
 * (e.g. presales step navigation). Never surface that as a user-facing error.
 */
export const safeRefetchQuery = async (
  refetch: () => Promise<unknown>,
  isUninitialized?: boolean,
): Promise<void> => {
  if (isUninitialized) {
    return;
  }
  try {
    await refetch();
  } catch {
    // Query skipped, torn down during route change, or never subscribed.
  }
};
